import { useSearch } from "@tanstack/react-router"
import { useCallback } from "react"
import type { Client } from "urql"

import type { ClassificationListSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { queryClient } from "@/providers/GraphqlRouterProvider"
import {
  type ClassificationsSearchFilters,
  useClassificationsSearchStore,
} from "@/screens/ManageProducts/stores/useProductClassesSearchStore"

interface UseSearchListReturn {
  searchParams: {
    query?: string
    field: ClassificationListSortField
    order: SortingOrder
    isActive?: boolean | null
  }
  executeSearch: (client: Client, filters: ClassificationsSearchFilters, skipFilterCheck?: boolean) => Promise<void>
  refetchData: (skipCheck?: boolean) => Promise<void>
}

const useSearchList = (): UseSearchListReturn => {
  const currentSearch = useSearch({ from: "/app/admin/manage-products/_layout/classes" })
  const { query, field, order } = currentSearch
  const executeSearch = useClassificationsSearchStore(({ executeSearch }) => executeSearch)

  const refetchData = useCallback(
    async (skipCheck = true) => {
      return executeSearch(queryClient, currentSearch, skipCheck)
    },
    [currentSearch, executeSearch]
  )

  return {
    searchParams: {
      query,
      field,
      order,
    },
    executeSearch,
    refetchData,
  }
}

export default useSearchList
